import CheckoutOverlay from '../../../../../v2/components/CheckoutOverlay/CheckoutOverlay';
import OpenpayOverlayLazyLoader from './OpenpayOverlayLazyLoader';

function OpenpayOverlay() {
  return (
    <CheckoutOverlay
      popup
      nopadding
      fullscreenMobile
    >
      <OpenpayOverlayLazyLoader />
    </CheckoutOverlay>
  );
}

OpenpayOverlay.propTypes = {};

export default OpenpayOverlay;
